export default "/images/vendor/flag-icon-css/flags/1x1/ai.svg?8eb1e0e559b7fb35fed99836b2eed7b9";